import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

// interface QueryParameters {
//   limit?: number;
//   [key: string]: any;
// }
export default {
  /**
   * Fetch devices API
   * @param {any} query query
   * @returns {any} promise
   */
  fetchDevices: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/list-all-charging-transactions`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch charging session API
   * @returns {any} promise
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-transaction/list-filters`);
  },
  /**
   * Create the user api call function
   * @param {any} data data
   * @returns {any} promise
   */
  anyCommand: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.ocppOnlyApiUrl}api/charging-point/v1/events/any-command`, {
      ...parameters,
    });
  },
  /**
   * Remote stop transaction API
   * @param {any} data - The request data
   * @returns {Promise<any>} A promise that resolves with the response
   */
  remoteStopTransaction: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.cpo.sessionsApiUrl}api/cpo/v1/charging-transaction/stop-transaction`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Create the user api call function
   * @param {any} data data
   * @returns {any} promise
   */
  stopTransaction: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/ocpp-events/admin-stop-transaction`, {
      ...parameters,
    });
  },
};
